<script lang="ts">
  import { t } from '../i18n';
  import { scaleMode, setScaleMode } from '../state/stores';

  const modes = ['overview', 'realistic'] as const;
</script>

<div class="segmented" role="group" aria-label={$t('mode.label')}>
  {#each modes as mode (mode)}
    <button
      type="button"
      aria-pressed={$scaleMode === mode}
      class:active={$scaleMode === mode}
      onclick={() => setScaleMode(mode)}
      title="{$t('mode.switchTo', { mode: $t(`mode.${mode}`) })} (M)"
    >
      {$t(`mode.${mode}`)}
    </button>
  {/each}
</div>
